<template>
  <div>
    <div class="cms-news-list-item-header">
      <a :href="newsLink" class="cms-news-list-item-header__back-link">
        <svg-icon icon="straight-arrows/right" class="cms-news-list-item__arrow" viewBox="0 0 16 16"/>
        <span>{{ $res.Views.News_BackToNewsList }}</span>
      </a>
      <div class="cms-news-list-item-header__title">
        {{ viewModel.title }}
      </div>
      <div v-if="viewModel.publicationDateTimeUtc" class="cms-news-list-item-header__date">
        <span class="text-second-20">{{ $formatDateLong(viewModel.publicationDateTimeUtc) }}</span>
        <svg-icon v-if="viewModel.isPinned" icon="pin" />
      </div>
    </div>
    <article class="cms-news-list-item">
      <img v-if="viewModel.summaryImageUrl"
           class="cms-news-list-item__img"
           :src="viewModel.summaryImageUrl" />
      <component :is="htmlContent"/>
    </article>
  </div>
</template>

<script>
import SvgIcon from "@/common/controls/SvgIconControl.vue";
import { createAppConfig } from "@/staticPage/StaticPage.ts";

export default {
  components: {
    SvgIcon
  },
  props: {
    viewModel: Object,
  },
  data() {
    return {
      htmlContent: null
    }
  },
  computed: {
    newsLink() {
      if(this.viewModel.newsFeedItemHotelId != null) {
        return `/hotel/${this.viewModel.newsFeedItemHotelId}/news`;
      }
      return '/news';
    }
  },
  created() {
    const runtimeStaticContent = createAppConfig({template: this.viewModel.htmlContent});
    this.htmlContent = runtimeStaticContent;
  }
}
</script>

<style lang="scss">
@use "../staticPage/static";
</style>

<style lang="scss" scoped>
.cms-news-list-item-header {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cms-news-list-item-header__back-link {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 13px;
  width: fit-content;
}

.cms-news-list-item-header__title {
  font-size: 28px;
  line-height: 44px;
  font-weight: 600;
}

.cms-news-list-item-header__date {
  display: flex;
  gap: 8px;
  align-items: center;
}

.cms-news-list-item {
  margin-block-start: 20px;
  display: flex;
  flex-flow: column;
  gap: 10px;

  padding: 20px 24px;
  background-color: #fff;
  border-radius: var(--border-radius-lg);
}

.cms-news-list-item__header {
  color: var(--second-20);
}

.cms-news-list-item__img {
  width: 800px;
  height: 240px;
  object-fit: cover;
  border-radius: 4px;
}

.cms-news-list-item__arrow {
  transform: rotate(180deg);
}

.text-second-20 {
  color: var(--second-20);
}
</style>
